import type { BusinessProfileInput } from '../../types/businessProfile.js';
import type { BotBusinessHours } from '../../types/leadBot.js';

// An EMPTY Business Profile, and the wording defaults. PURE.
//
// ⚠️ EMPTY MEANS EMPTY. The fitness prompt states outright when a section has
// nothing in it ("you have been told nothing, so you can confirm nothing"), so a
// blank profile makes a polite deflection machine rather than a bot inventing a
// club. The seed script (and, later, the brief import) is what fills one.

export const DEFAULT_STAFFED_TIMEZONE = 'Australia/Brisbane';

/** No staffed windows = the club is never staffed (stated, not assumed open). */
export function emptyStaffedHours(timezone: string = DEFAULT_STAFFED_TIMEZONE): BotBusinessHours {
  return { timezone, windows: [] };
}

export function emptyProfileInput(
  timezone: string = DEFAULT_STAFFED_TIMEZONE,
): BusinessProfileInput {
  return {
    club: {
      displayName: '',
      address: '',
      parking: '',
      phone: '',
      email: '',
      joinUrl: '',
      reviewUrl: '',
      instagramUrl: '',
    },
    hours: {
      access24x7: false,
      accessHoursText: '',
      staffedHours: emptyStaffedHours(timezone),
      publicHolidayNote: '',
      tourTimesGuidance: '',
    },
    team: [],
    videos: [],
    differentiators: {
      topReasons: '',
      typicalMember: '',
      competitors: '',
      facilities: '',
      doNotHave: '',
    },
    memberships: [],
    fees: [],
    addOns: [],
    policies: {
      contract: '',
      cancellation: '',
      freeze: '',
      coolingOff: '',
      billing: '',
      reciprocalAccess: '',
      guests: '',
    },
    voice: {
      tones: [],
      emoji: 'sparingly',
      localSlang: '',
      neverSay: '',
      alwaysSay: '',
      useFirstNames: true,
      teReo: 'no',
      sampleMessage: '',
    },
    faqs: [],
    objections: [],
    discounting: { canDiscount: false, pushBackReply: '' },
    extraHardStops: '',
    messages: {
      handover: '',
      notSure: '',
      optOutConfirmation: '',
      distress: '',
      includeStopFooter: true,
      bookingConfirmation: '',
    },
    booking: { tourMinutes: 15, whatToBring: '', whereToGo: '' },
  };
}
